import React from 'react';
import { useLang } from '../LangContext';

interface Props {
  failed: boolean;
}

const BookingLoading = ({ failed }: Props) => {
  const { t } = useLang();
  return (
    <main className="booking-page booking-page-loading">
      <div className="booking-loading-card">
        {failed ? (
          <>
            <h2>{t.bookingLoadFailed}</h2>
            <p>{t.bookingLoadFailedDesc}</p>
          </>
        ) : (
          <>
            <div className="booking-loading-spinner" aria-hidden="true" />
            <p>{t.bookingLoadingText}</p>
          </>
        )}
      </div>
    </main>
  );
};

export default BookingLoading;
